import baseAPI from '../../axiosApi'

const api={
    list:'/api-ir/bachelor/paperInspect/page',
    add:'/api-ir/bachelor/paperInspect/add',
    update:'/api-ir/bachelor/paperInspect/edit',
    info:'/api-ir/bachelor/paperInspect/get/',
    del:'/api-ir/bachelor/paperInspect/delete/',
    export:'/api-ir/bachelor/paperInspect/export',
    check:'/api-ir/bachelor/paperCheck/check',
    middleInspect:'/api-ir/bachelor/paperInspect/middleInspect',
    college:'/api-ir/bachelor/paperInspect/college',
    collegeCommit:'/api-ir/bachelor/paperInspect/collegeCommit'
}
// 查询试卷抽查列表
export function list (data) {
    return baseAPI.axiosData(api.list,'get',data)
}
// 新增试卷抽查
export function add (data) {
    return baseAPI.axiosData(api.add,'post',data)
}
// 修改试卷抽查
export function update (data) {
    return baseAPI.axiosData(api.update,'put',data)
}
// 查询试卷抽查信息
export function info (id) {
    return baseAPI.axiosData(api.info+id,'get')
}
// 删除试卷抽查
export function del (id) {
    return baseAPI.axiosData(api.del+id,'delete')
}
// 导出试卷抽查信息
export function exportFile (data) {
    return baseAPI.axiosData(api.export,'get',data)
}

export function check (data) {
    return baseAPI.axiosData(api.check,'get',data)
}

export function college (data) {
    return baseAPI.axiosData(api.college,'post',data)
}

export function middleInspect (data) {
    return baseAPI.axiosData(api.middleInspect,'post',data)
}

export function collegeCommit (data) {
    return baseAPI.axiosData(api.collegeCommit,'post',data)
}